export default __webpack_public_path__ + "4a74de8feead868e6f35b21bcaae809c.svg";